import React, { useEffect, useRef, useState } from "react";
import FireOnMenu from "./FireOnMenu";
import DashboardMenu from "./DashboardMenu";
import { useLocation, useParams } from "react-router-dom";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import { API_HOST } from "../../Constants";
import PageHeader from "../PageHeader";

export default function BuildingInfoComponent() {
  const { id } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [dataSource, setDataSource] = useState(null);
  const trackRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideCount, setSlideCount] = useState(0);

  useEffect(() => {
    apiWrapper(async () => {
      const { status, data } =
        await fireonApi.getFireFightingObjectBuildingStatus(id);
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    });
  }, []);

  useEffect(() => {
    let startX = 0;
    let isSwiping = false;

    const track = trackRef.current;

    const onTouchStart = (e) => {
      startX = e.touches[0].clientX;
      isSwiping = true;
    };

    const onTouchMove = (e) => {
      if (!isSwiping) return;
      const deltaX = e.touches[0].clientX - startX;
      if (Math.abs(deltaX) > 50) {
        if (deltaX < 0) {
          setCurrentSlide((prev) => (prev + 1) % slideCount);
        } else {
          setCurrentSlide((prev) => (prev - 1 + slideCount) % slideCount);
        }
        isSwiping = false;
      }
    };

    const onTouchEnd = () => {
      isSwiping = false;
    };

    if (track) {
      track.addEventListener("touchstart", onTouchStart);
      track.addEventListener("touchmove", onTouchMove);
      track.addEventListener("touchend", onTouchEnd);
    }

    return () => {
      if (track) {
        track.removeEventListener("touchstart", onTouchStart);
        track.removeEventListener("touchmove", onTouchMove);
        track.removeEventListener("touchend", onTouchEnd);
      }
    };
  }, [slideCount]);

  useEffect(() => {
    window.addEventListener("resize", setSlideWidths);
    setTimeout(setSlideWidths, 0); // slight delay to ensure DOM is ready

    return () => window.removeEventListener("resize", setSlideWidths);
  }, [dataSource]);

  useEffect(() => {
    updateSlide();
  }, [currentSlide]);

  const updateSlide = () => {
    const slideWidth = window.innerWidth;
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${currentSlide * slideWidth
        }px)`;
    }
  };

  const setSlideWidths = () => {
    const slideWidth = window.innerWidth;
    const slides = trackRef.current?.children || [];
    Array.from(slides).forEach((slide) => {
      slide.style.width = `${slideWidth}px`;
    });

    if (trackRef.current) {
      trackRef.current.style.width = `${slideWidth * slides.length}px`;
    }

    setSlideCount(slides.length);
    updateSlide();
  };

  return (
    <section id="darkMode" class="mbSection darkMode pb-per">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      {dataSource && (
        <>
          <div class="container overContainer">
            <p class="tableTitle mb-10">건축물정보</p>
            <div class="building-img-slider">
              <div ref={trackRef} class="building-img-track">
                {dataSource.photos.length > 0 ? (
                  dataSource.photos.map((item, index) => (
                    <div class="building-img-wrap">
                      <img src={API_HOST + item.photoImage} alt="" />
                    </div>
                  ))
                ) : (
                  <div>
                    <p>등록된 건물 사진이 없습니다.</p>
                  </div>
                )}
              </div>
              <div class="slider-dots">
                {Array.from({ length: slideCount }).map((_, i) => (
                  <div
                    key={i}
                    className={`dot ${i === currentSlide ? "active" : ""}`}
                    onClick={() => setCurrentSlide(i)}
                  />
                ))}
              </div>
            </div>
            <div class="building-title-wrap">
              <p class="title">{dataSource.basicInfo.name}</p>
              <p class="sub">{dataSource.basicInfo.address}</p>
            </div>
          </div>
          <div class="black-divi"></div>
          <div class="container pb-125">
            <div class="building-item-wrap">
              <p class="wrap-title">건축물 기초 정보</p>
              <div class="dashedBox">
                <div class="dashed-item">
                  <p class="dashed-title">주용도</p>
                  <p class="dashed-txt">{dataSource.basicInfo.mainUse}</p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">주구조</p>
                  <p class="dashed-txt">{dataSource.basicInfo.mainStructure}</p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">준공일</p>
                  <p class="dashed-txt">
                    {dataSource.basicInfo.completionDate}
                  </p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">사용승인일</p>
                  <p class="dashed-txt">{dataSource.basicInfo.approvalDate}</p>
                </div>
              </div>
              <div class="dashedBox">
                <div class="dashed-item">
                  <p class="dashed-title">층수</p>
                  <p class="dashed-txt">{dataSource.basicInfo.floorCount}</p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">연면적</p>
                  <p class="dashed-txt">
                    {dataSource.basicInfo.totalFloorArea}
                  </p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">건축면적</p>
                  <p class="dashed-txt">{dataSource.basicInfo.buildingArea}</p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">용적율</p>
                  <p class="dashed-txt">
                    {dataSource.basicInfo.floorAreaRatio}
                  </p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">지붕구조</p>
                  <p class="dashed-txt">{dataSource.basicInfo.roofStructure}</p>
                </div>
                <div class="dashed-item">
                  <p class="dashed-title">소방안전관리자</p>
                  <p class="dashed-txt">{dataSource.basicInfo.safetyManager}</p>
                </div>
              </div>
            </div>
            <div class="building-item-wrap">
              <p class="wrap-title">건축물 상세 현황</p>
              <div class="dashedBox col-dashedBox">
                {dataSource.floorDetails &&
                  dataSource.floorDetails.map((item, index) => (
                    <div class="dashed-item">
                      <p class="dashed-title">{item.floor}</p>
                      <div class="item-wrap">
                        <p class="dashed-txt">{item.structure}</p>
                        <span class="divi"></span>
                        <p class="dashed-txt">{item.area} m²</p>
                      </div>
                      <p class="dashed-txt">{item.use}</p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </>
      )}
      <div id="dashboardMenu" class="active_04">
        <DashboardMenu buildingName={buildingName} />
      </div>
      <FireOnMenu />
    </section>
  );
}
